<template>
  <div class="navbartournamentbutton">
    <div class="navbartournamentbutton__label" v-if="!getModal">
      Elegir Torneo:
    </div>
    <div role="button" class="tournament-button" @click="onClickButton">
      <template v-if="!getModal">
        <div class="tournament-button__logo">
          <img :src="imgLiga" />
        </div>
        <div class="tournament-button__info">
          <div class="tournament-button__info__tournament">
            {{ getTournamentsNameSelected }}
          </div>
          <div class="tournament-button__info__season">
            {{ getSeasonsNameSelected }}
          </div>
        </div>
        <div class="tournament-button__arrow">
          <img src="https://golstatsimages.blob.core.windows.net/todoelfut/arrow-selelct.png" />
        </div>
      </template>
      <template v-else>
        <div class="tournament-button__close-text">
          Cerrar
        </div>
        <div class="tournament-button__close-icon">
          <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_close.png" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'NavBarTournamentButton',
  computed: {
    ...mapGetters('loginGeneral', [
      'getModal',
      'getTournamentSelected',
      'getSeasonSelected',
      'getTournamentsNameSelected',
      'getSeasonsNameSelected',
    ]),
    imgLiga() {
      if (this.getTournamentSelected === 33) {
        return 'https://golstatsimages.blob.core.windows.net/todoelfut/' + this.getSeasonSelected + '.png';
      } else {
        return 'https://golstatsimages.blob.core.windows.net/todoelfut/' + this.getTournamentSelected + '.png';
      }
    },
  },
  methods: {
    ...mapMutations('loginGeneral', ['setModal']),
    onClickButton() {
      this.setModal(!this.getModal);
    },
  },
};
</script>

<style scoped lang="scss">
.navbartournamentbutton {
  width: 100%;
  height: auto;
  // background: greenyellow;
  display: inline-flex;
  @media screen and (max-width: 1200px) {
    display: inline-block;
    align-content: center;
    align-items: center;
    position: relative;
  }
  &__label {
    // background: red;
    font-family: 'Avenir-Demi-Medium';
    display: inline-flex;
    align-content: center;
    align-items: center;
    margin-right: 10px;
    font-size: 11.6px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.5;
    letter-spacing: normal;
    text-align: left;
    color: #fff;
    @media screen and (max-width: 1200px) {
      position: absolute;
      align-content: left;
      align-items: left;
      width: 100%;
      height: 10px;
      left: 20px;
      top: -6px;
      font-size: 9px;
    }
    @media screen and (max-width: 1024px) {
      top: -3px;
      left: 10px;
    }
  }
}
.tournament-button {
  padding: 8px 16px 4px;
  border-radius: 25px;
  border: solid 1px #fff;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  color: white;
  cursor: pointer;
  @media screen and (max-width: 1200px) {
    margin-top: 7px;
    padding: 6px 8px 0px;
  }
  @media screen and (max-width: 1024px) {
    margin-top: 7px;
    padding: 4px 6px 0px;
    height: 32px;
  }
  &__arrow {
    margin-left: 10px;
    @media screen and (max-width: 1024px) {
      margin-left: 6px;
    }
    & > img {
      @media screen and (max-width: 1024px) {
        width: 24px;
      }
    }
  }
  &__logo {
    height: 36px;
    @media screen and (max-width: 1200px) {
      height: 24px;
    }
    @media screen and (max-width: 1024px) {
      height: 20px;
    }

    & > img {
      height: 36px;
      @media screen and (max-width: 1200px) {
        height: 24px;
      }
      @media screen and (max-width: 1024px) {
        height: 20px;
      }
    }
  }

  &__info {
    margin-left: 0.5em;
    text-align: left;
    font-family: Heebo, sans-serif;

    &__tournament {
      font-size: 18px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.06;
      letter-spacing: normal;
      text-align: left;
      @media screen and (max-width: 1200px) {
        font-size: 16px;
        line-height: 1.12;
      }
      @media screen and (max-width: 1024px) {
        font-size: 13px;
        line-height: 0.9;
      }
    }
    &__season {
      font-size: 10px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 0.8;
      letter-spacing: normal;
      text-align: left;
      @media screen and (max-width: 1200px) {
        font-size: 9px;
      }
      @media screen and (max-width: 1024px) {
        font-size: 8px;
        line-height: 1.2;
      }
    }

    @media screen and (max-width: 420px) {
      &__tournament {
        font-size: 13px;
      }

      &__season {
        margin-top: 2px;
        font-size: 9px;
      }
    }
  }

  &__close-text {
    font-family: Heebo, sans-serif;
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.06;
    letter-spacing: normal;
    color: #fff;
    margin-bottom: 4px;
    @media screen and (max-width: 1200px) {
      margin-left: 15px;
    }
  }

  &__close-icon {
    height: 20px;
    width: 20px;
    margin-left: 1em;
    margin-bottom: 4px;

    & > img {
      height: 13px;
      width: 13px;
    }
  }
}
</style>
